import { yupResolver } from "@hookform/resolvers/yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { createCurrencyManager, resetListCurrencyManager } from "store/actions";
import * as yup from "yup";
import { emailPrefix, userRecordStatus, userRecordStatusMode } from "./utils";

const CreateUser = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["currencyManager"]);
  const { addToast } = useToasts();

  const userManagement = useSelector(state => state.CurrencyManager);
  const {
    loadingCreate,
    errorCreate,
    create: userCreate,
    loadingListRole,
    errorListRole,
    listRole: userRoleList,
  } = userManagement;
  const schema = yup.object().shape({
    dvtte: yup.string(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      dvtte: "",
      // record_status: userRecordStatusMode.ACTIVE,
    },
  });

  // Get List Data For Select
  useEffect(() => {
    // dispatch(listEmployee({ page: -1 }));
    // dispatch(listUserRole());
    // return () => {
    //   dispatch(resetListEmployee());
    //   dispatch(resetListUserRole());
    // };
  }, [dispatch]);

  // Action Dispatch
  useEffect(() => {
    if (userCreate && userCreate.success) {
      addToast(t("form.submit.create.user.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetListCurrencyManager());
      setTimeout(() => {
        history.push("/currency-manager/list");
      }, 1000);
    }
  }, [addToast, dispatch, history, t, userCreate]);

  const setDataUserProfile = data => {
   
    setValue("dvtte", userProfile.dvtte ? userProfile.dvtte : "");
  };

  const onSubmit = values => {
    dispatch(
      createCurrencyManager({
        dvtte: values.dvtte,
      })
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.create")}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title={t("title.manager")}
            breadcrumbItem={t("title.create")}
          />
          <Row className="row-cols-1 EmployeeCreate">
            <Col>
              <Card className="EmployeeCreate__Card">
                <CardBody>
                  <Form>
                    <Row className="row-cols-1 row-cols-md-2">
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="dvtte">{t("table.dvtte")}</Label>
                          <input
                            maxLength={3}
                            type="text"
                            className="form-control"
                            {...register("dvtte")}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="justify-content-end">
                      <Col className="col-auto">
                        <Button
                          color="primary"
                          className="btn-label"
                          type="button"
                          onClick={() => {
                            handleSubmit(onSubmit)();
                          }}
                          disabled={loadingListRole || loadingCreate}
                        >
                          <i className="bx bx-save label-icon"></i>
                          {t("form.save")}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateUser;
